import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import "animate.css";
import "material-design-icons-iconfont";
// import 'material-design-icons'
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.min.css"; // 根据实际路径和文件修改
import "./assets/font/font.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw/dist/leaflet.draw.js";
import turf from "turf";

Vue.prototype.axios = axios;

Vue.use(turf);
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
//浏览器打印后端返回对象时数值不隐藏
Vue.prototype.print = (obj, type) => {
  type = type || "log";
  const log = JSON.parse(JSON.stringify(obj));
  console[type](log);
};
/* leaflet icon */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

Vue.prototype.setCookie = function (cname, value) {
  if (value !== "") {
    localStorage.setItem(cname, value);
  } else {
    localStorage.removeItem(cname);
  }
};

Vue.prototype.getCookie = function (cname) {
  return localStorage.getItem(cname);
};

Vue.prototype.openUrlInNewWindow = function (url) {
  let routeUrl = this.$router.resolve({
    path: url,
  });
  window.open(routeUrl.href, "_blank");
};

Vue.prototype.findRealParent = function (firstVueParent) {
  let found = false;
  while (firstVueParent && !found) {
    if (firstVueParent.main === undefined) {
      firstVueParent = firstVueParent.$parent;
    } else {
      found = true;
    }
  }
  return firstVueParent;
};
Vue.prototype.bus = new Vue();
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'))
  // }
}).$mount("#app");
